import winterTimezones from '@dashboard/components/timezones/winterTimezones';
import moment from 'moment';

export interface Timezone {
  label: string;
  value: number;
  valueStr: string;
}

export function getTimezones(isSummerTime: boolean): Timezone[] {
  return winterTimezones.map(({ rawLabel, baseValue }) => {
    const adjustedValue = baseValue + (isSummerTime ? 1 : 0);

    const valueStr =
      adjustedValue >= 0
        ? `+${String(adjustedValue).padStart(2, '0')}:00`
        : `${String(adjustedValue).padStart(3, '0')}:00`;

    const label = `GMT${valueStr} ${rawLabel.replace(/^\(UTC[^)]+\)\s*/, '')}`;

    return {
      label,
      value: adjustedValue,
      valueStr,
    };
  });
}
export const TIMEZONES = getTimezones(moment().isDST());
